import styled from 'styled-components'
import { Button, Box, Tooltip } from '@mui/material'
import { LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { StepsHeader } from '../../components'
import { useOnboarding } from '../../contexts/OnboardingContext'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;

  > span + span {
    margin-bottom: 24px;
  }
`

const Footer = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`

const CaffeineTime = ({ onNext, onPrevious }) => {
  const { caffeineTime, setCaffeineTime } = useOnboarding()
  const { t } = useTranslation('common')

  return (
    <Container>
      <div>
        <StepsHeader
          stepText={t('onboarding.four_steps.four')}
          description={t('onboarding.caffeine.time.description')}
        />

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ContentContainer>
            <span
              style={{ fontSize: 24, fontWeight: 700, textAlign: 'center' }}
            >
              {t('onboarding.caffeine.time.question')}
            </span>
            <span style={{ fontSize: 18, textAlign: 'center' }}>
              {t('onboarding.caffeine.time.input_request')}
            </span>
            <MobileTimePicker
              label={t('onboarding.caffeine.time.placeholder')}
              ampm={false}
              minutesStep={15}
              value={caffeineTime}
              onChange={newValue => setCaffeineTime(newValue)}
            />
          </ContentContainer>
        </LocalizationProvider>
      </div>
      <Footer>
        <Button
          variant='text'
          onClick={onPrevious}
          startIcon={<ArrowBackIcon />}
        >
          {t('onboarding.return')}
        </Button>
        {!caffeineTime ? (
          <Tooltip
            title='Selecione um horário para continuar'
            placement='top'
            arrow
          >
            <span>
              <Button
                variant='contained'
                disabled
              >
                {t('onboarding.advance')}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            variant='contained'
            onClick={onNext}
          >
            {t('onboarding.advance')}
          </Button>
        )}
      </Footer>
    </Container>
  )
}

export default CaffeineTime
